import * as React from "react";
import { LogoutController } from "@njoy/controller";
import { useNavigate } from "react-router-dom";
import { CallLogout } from "./CallLogout";
import {
  useDisableMyPushSubscriptions,
  useUnregisterPushSubscription,
} from "@njoy/controller";
import { disableBrowserPush } from "src/utils/pushNotifications";

export const Logout: React.FC = () => {
  const navigate = useNavigate();
  const { unregisterPushSubscription } = useUnregisterPushSubscription();
  const { disableMyPushSubscriptions } = useDisableMyPushSubscriptions();

  const onFinish = () => {
    navigate("/login");
  };

  return (
    <LogoutController>
      {({ logout }) => (
        <CallLogout
          logout={async () => {
            await disableBrowserPush({
              unregisterPushSubscription,
              disableMyPushSubscriptions,
              persistOptOut: false,
            });
            await logout();
          }}
          onFinish={onFinish}
        />
      )}
    </LogoutController>
  );
};